/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "esperanto": {
        "nested": {
          "common": {
            "nested": {
              "CardType": {
                "values": {
                  "UNKNOWN_CARD_TYPE": 0,
                  "CREDIT": 1,
                  "DEBIT": 2
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.esperanto?.nested?.common?.nested?.CardType) {
  $root.addJSON(jsonData);
}

/**
 * the type of card being used
 *
 * SOURCE CardType @ squareup/esperanto/common/async_transaction_common.proto at 8:1
 */
export const CardType = $root.lookupEnum('squareup.esperanto.common.CardType').values;